module.exports = __webpack_public_path__ + "img/radiation-solid.eb332fb6.svg";